var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.imgWrapper},[_c('img',{class:_vm.$style.image,attrs:{"src":_vm.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }